import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const SidebarMenu = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: true,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
        ],
      },
    ],
  },
  {
    tittle: "HRM",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        id: "Academics Management",
        label: "Academics",
        link: routes.curriculum,
        submenu: true,
        showSubRoute: false,
        icon: "book",
        base: "academics",
        materialicons: "people",
        submenuItems: [
          {
            label: "Academic Lens",
            link: routes.academiclens,
            base: "academics",
            base2: "academics-list",
          },
          {
            label: "Curriculum",
            link: routes.curriculum,
            base: "academics",
            base2: "academics-list",
          },
          {
            label: "Course",
            link: routes.courses,
            base: "academics",
          },
          {
            label: "Subject",
            link: routes.subjects,
            base: "academics",
          },
          {
            label: "Syllabus",
            link: routes.syllabus,
            base: "Syllabus",
          },
        ],
      },
      {
        id: "Class Management",
        label: "Learning-Center",
        link: routes.curriculum,
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "school",
        materialicons: "school",
        submenuItems: [
          {
            label: "Classes",
            link: routes.class,
            base: "classes",
            base2: "class-list",
          },
          {
            label: "Students",
            link: routes.students,
            base: "students",
            base2: "student-list",
          },
        ],
      },
      {
        id: "Online Business",
        label: "Online Learning Center",
        link: routes.subscriptions,
        submenu: true,
        showSubRoute: false,
        icon: "shopping-cart",
        base: "online-bizz",
        materialicons: "business",
        submenuItems: [
          {
            label: "Subscriptions",
            link: routes.subscriptions,
            base: "subscriptions",
            base2: "subscription-list",
          },
          {
            label: "User Subscriptions",
            link: routes.userSubscriptions,
            base: "user-subscriptions",
            base2: "user-subscription-list",
          },
          {
            label: "Order & Payments",
            link: routes.paymentTransactions,
            base: "payments",
            base2: "payment-list",
          },
        ],
      },
      {
        id: "Calendar Management",
        label: "Calendar",
        link: routes.holidays,
        base: "holidays",
        submenu: false,
        showSubRoute: false,
        icon: "calendar-event",
        materialicons: "confirmation_number",
        submenuItems: [],
      },
      {
        id: "Attendance Management",
        label: "Attendance",
        link: "leaves",
        submenu: true,
        showSubRoute: false,
        icon: "file-time",
        base: "true",
        materialicons: "track_changes",
        submenuItems: [
          {
            label: "Attendance",
            customSubmenuTwo: true,
            submenu: false,
            showSubRoute: false,
            link: routes.attendance,
            base: "attendance",
          },
          {
            label: "Leaves",
            customSubmenuTwo: true,
            submenu: false,
            showSubRoute: false,
            link: routes.leaveadmin,
            base: "leaves",
          },
        ],
      },
      {
        id: "Performance Management",
        label: "Performance",
        link: "assessments",
        submenu: true,
        showSubRoute: false,
        icon: "graph",
        base: "assessments",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Assessments",
            customSubmenuTwo: true,
            submenu: false,
            showSubRoute: false,
            link: routes.assessments,
            base: "assessments",
          },
        ],
      },
      {
        id: "Employee Management",
        label: "Employees",
        link: routes.employeeList,
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "employees",
        materialicons: "people",
        submenuItems: [
          {
            label: "Employees",
            link: routes.employeeList,
            base: "employees",
            base2: "employee-list",
          },
          {
            label: "Departments",
            link: routes.departments,
            base: "departments",
          },
          {
            label: "Designations",
            link: routes.designations,
            base: "designations",
          },
        ],
      },
    ],
  },
  {
    tittle: "ADMINISTRATION",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        id: "Settings Management",
        label: "Settings",
        link: routes.chatSettings,
        submenu: true,
        showSubRoute: false,
        icon: "settings",
        base: "settings",
        materialicons: "settings",
        submenuItems: [
          {
            label: "Feature Settings",
            link: routes.chatSettings,
            base: "chat_settings",
            base2: "settings",
          },
          {
            label: "Application Settings",
            link: routes.learningCenter,
            base: "feature_control",
            base2: "settings",
          },
        ],
      },
      {
        id: "User Management",
        label: "Access Management",
        link: routes.rolesPermissions,
        submenu: true,
        showSubRoute: false,
        icon: "key",
        base: "access_management",
        materialicons: "people",
        submenuItems: [
          {
            label: "Roles and permissions",
            link: routes.rolesPermissions,
            base: "roles_and_permissions",
            base2: "access_management",
          },
        ],
      },
      {
        id: "IT Support",
        label: "IT Support",
        link: routes.tickets,
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Tickets",
            link: routes.tickets,
            base: "ticket-list",
          },
        ],
      },
    ],
  },
];
